import { vesselsTranslator } from './translators/vessels';
import {
  createDocumentDomainHook,
  createDomainUpdateHook,
} from './domainHookFactory';
import type { VesselSettings } from './types';

export const useVesselsSettings = createDocumentDomainHook<VesselSettings>(
  'vessels',
  vesselsTranslator,
);

export const useUpdateVesselsSettings =
  createDomainUpdateHook<VesselSettings>(useVesselsSettings);
